import {GetSuperAuthObject} from "./authentication/AuthFunctions";

export const GetDeviceID = async () => {
    let deviceID= localStorage.getItem("deviceID");

    if(!deviceID){
        try {
            const response = await fetch('Analytics/GenerateDeviceID', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            const json = await response.json()

            localStorage.setItem("deviceID", json.id);
            deviceID = localStorage.getItem("deviceID");
        } catch (e) {
            console.log(e)
        }
    }

    return deviceID;
}

export const GetOS = () => {
    let userAgent = navigator.userAgent;
    let operatingSystem = "Unknown OS";

    if (userAgent.indexOf("Win") !== -1) operatingSystem = "Windows";
    else if (userAgent.indexOf("Android") !== -1) operatingSystem = "Android";
    else if (userAgent.indexOf("like Mac") !== -1) operatingSystem = "iOS";
    else if (userAgent.indexOf("Mac") !== -1) operatingSystem = "MacOS";
    else if (userAgent.indexOf("Linux") !== -1) operatingSystem = "Linux";

    return operatingSystem;
}

export const GetBrowser = () => {
    let userAgent = navigator.userAgent;
    let browser = "Unknown Browser";

    if (userAgent.indexOf("Chrome") !== -1) browser = "Chrome";
    else if (userAgent.indexOf("Safari") !== -1) browser = "Safari";
    else if (userAgent.indexOf("Firefox") !== -1) browser = "Firefox";
    else if (userAgent.indexOf("MSIE") !== -1 || userAgent.indexOf("Trident/") !== -1) browser = "Internet Explorer";
    else if (userAgent.indexOf("Edge") !== -1) browser = "Edge";

    return browser;
}

export const RegisterEvent = async ({source, sequenceID, token, action = 'VISIT'}) => {
    try {
        const superAuth = GetSuperAuthObject()

        if(superAuth && superAuth.token){
            return;
        }

        const response = await fetch('Analytics/RegisterEvent', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify({
                ANA_ACTION: action,
                ANA_ANONYMOUS_ID: await GetDeviceID(),
                ANA_SOURCE: source,
                ANA_SEQUENCE_ID: sequenceID,
                ANA_OS: GetOS(),
                ANA_BROWSER: GetBrowser()
            })
        });

        await response.json()
    } catch (e) {
        console.log(e)
    }
}